export default __webpack_public_path__ + "static/media/linkedin.9e52cf32.svg";